class ProductUpsell {
  constructor() {
    this.init();
  }

  init() {
    this.setupUpsellCheckboxes();
    this.setupQuantitySelectors();
    this.initializeQuantityInputs();
    this.modifyAddToCartForm();
  }

  setupUpsellCheckboxes() {
    const upsellCheckboxes = document.querySelectorAll('.upsell-checkbox');
    const upsellItems = document.querySelectorAll('.upsell-product-item');
    
    upsellCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        this.handleUpsellSelection(e.target);
      });
    });

    // 让整个产品项目都可以点击
    upsellItems.forEach(item => {
      item.addEventListener('click', (e) => {
        // 如果点击的是checkbox本身、数量选择器或其子元素，不要重复处理
        if (e.target.classList.contains('upsell-checkbox') || 
            e.target.closest('.upsell-quantity-selector') ||
            e.target.closest('quantity-input')) {
          return;
        }
        
        const checkbox = item.querySelector('.upsell-checkbox');
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          this.handleUpsellSelection(checkbox);
        }
      });
    });
  }

  setupQuantitySelectors() {
    const quantityButtons = document.querySelectorAll('.upsell-quantity-selector .quantity__button');
    const quantityInputs = document.querySelectorAll('.upsell-quantity-selector .quantity-input');
    
    // 只阻止按钮点击事件冒泡，让主题的QuantityInput组件处理数量逻辑
    quantityButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation(); // 防止触发产品项目的点击事件
        
        // 延迟执行，等待主题的QuantityInput组件处理完数量变化
        setTimeout(() => {
          const productItem = button.closest('.upsell-product-item');
          const checkbox = productItem.querySelector('.upsell-checkbox');
          
          // 如果修改了数量，自动选中该产品
          if (!checkbox.checked) {
            checkbox.checked = true;
            this.handleUpsellSelection(checkbox);
          } else {
            // 如果已经选中，只更新价格
            this.updateTotalPrice();
          }
        }, 10);
      });
    });
    
    // 处理数量输入框变化
    quantityInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        e.stopPropagation();
        
        const productItem = input.closest('.upsell-product-item');
        const checkbox = productItem.querySelector('.upsell-checkbox');
        
        // 如果修改了数量，自动选中该产品
        if (!checkbox.checked) {
          checkbox.checked = true;
          this.handleUpsellSelection(checkbox);
        } else {
          this.updateTotalPrice();
        }
      });
      
      // 阻止数量输入框的点击事件冒泡
      input.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });
  }

  initializeQuantityInputs() {
    // 确保主题的QuantityInput组件被正确初始化
    const quantityInputs = document.querySelectorAll('.upsell-quantity-selector quantity-input');
    quantityInputs.forEach(quantityInput => {
      if (!quantityInput.hasAttribute('data-initialized')) {
        // 如果QuantityInput类存在，手动创建实例
        if (typeof QuantityInput !== 'undefined') {
          // 让浏览器自动处理custom element的初始化
          quantityInput.setAttribute('data-initialized', 'true');
        }
      }
    });
  }

  handleUpsellSelection(checkbox) {
    const productItem = checkbox.closest('.upsell-product-item');
    
    if (checkbox.checked) {
      productItem.classList.add('selected');
    } else {
      productItem.classList.remove('selected');
    }
    
    // 更新总价显示
    this.updateTotalPrice();
  }

  updateTotalPrice() {
    const selectedCheckboxes = document.querySelectorAll('.upsell-checkbox:checked');
    const totalPriceElement = document.querySelector('.upsell-total-price');
    const totalAmountElement = document.querySelector('.upsell-total-amount');
    
    if (!totalPriceElement || !totalAmountElement) return;
    
    let totalPrice = 0;
    
    selectedCheckboxes.forEach(checkbox => {
      const price = parseFloat(checkbox.dataset.price);
      const productItem = checkbox.closest('.upsell-product-item');
      const quantityInput = productItem.querySelector('.quantity-input');
      const quantity = parseInt(quantityInput?.value) || 1;
      
      if (!isNaN(price)) {
        totalPrice += price * quantity;
      }
    });
    
    if (selectedCheckboxes.length > 0) {
      // 显示总价
      totalAmountElement.textContent = this.formatMoney(totalPrice);
      totalPriceElement.style.opacity = '1';
    } else {
      // 隐藏总价
      totalPriceElement.style.opacity = '0';
    }
  }

  formatMoney(cents) {
    // 使用Shopify的货币格式化函数（如果可用）
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }
    
    // 后备方案：简单的美元格式化
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }

  modifyAddToCartForm() {
    const addToCartForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const submitButton = document.querySelector('.product_submit_button');
    
    if (!addToCartForm || !submitButton) return;

    submitButton.addEventListener('click', (e) => {
      const selectedUpsells = this.getSelectedUpsells();
      const hasFreeGift = this.hasFreeGift();
      
      // 如果有免费赠品，总是拦截默认行为来添加免费赠品
      if (hasFreeGift) {
        e.preventDefault();
        this.addProductsToCart(selectedUpsells);
      } else if (selectedUpsells.length > 0) {
        // 如果没有免费赠品但选择了upsell产品，也拦截默认行为
        e.preventDefault();
        this.addProductsToCart(selectedUpsells);
      }
      // 如果既没有免费赠品也没有选择upsell产品，让表单正常提交
    });
  }

  getSelectedUpsells() {
    const selectedCheckboxes = document.querySelectorAll('.upsell-checkbox:checked');
    const upsells = [];
    
    selectedCheckboxes.forEach(checkbox => {
      const productItem = checkbox.closest('.upsell-product-item');
      const quantityInput = productItem.querySelector('.quantity-input');
      const quantity = parseInt(quantityInput?.value) || 1;
      
      upsells.push({
        id: parseInt(checkbox.dataset.variantId),
        quantity: quantity
      });
    });
    
    return upsells;
  }

  async addProductsToCart(upsells) {
    const mainProductForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const mainProductData = new FormData(mainProductForm);
    const submitButton = document.querySelector('.product_submit_button');
    const buttonLabel = submitButton.querySelector('.btn-label');
    const loadingIcon = submitButton.querySelector('.icon-load');
    
    // 显示加载状态
    submitButton.disabled = true;
    if (loadingIcon) loadingIcon.style.opacity = '1';
    if (buttonLabel) buttonLabel.textContent = 'Adding to cart...';

    try {
      // 构建包含主产品和upsell产品的数据
      const items = [];
      
      // 添加主产品
      const mainProductId = mainProductData.get('id');
      const mainProductQuantity = mainProductData.get('quantity') || '1';
      
      items.push({
        id: parseInt(mainProductId),
        quantity: parseInt(mainProductQuantity)
      });
      
      // 添加选中的upsell产品
      upsells.forEach(upsell => {
        items.push(upsell);
      });

      // 如果有免费赠品，添加所有免费赠品
      const freeGiftsData = this.getFreeGiftData();
      if (freeGiftsData && freeGiftsData.length > 0) {
        freeGiftsData.forEach(gift => {
          items.push({
            id: gift.variantId,
            quantity: 1,
            properties: {
              '_free_gift': 'true'
            }
          });
        });
      }

      // 获取购物车组件用于sections
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      // 构建请求数据
      const requestData = { items };
      
      // 如果有购物车组件，添加sections信息
      if (cart) {
        requestData.sections = cart.getSectionsToRender().map((section) => section.id);
        requestData.sections_url = window.location.pathname;
      }

      // 发送到购物车
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        throw new Error('Failed to add products to cart');
      }

      const result = await response.json();
      
      // 根据是否选择了upsell产品决定行为
      if (upsells.length > 0) {
        // 选择了upsell产品，直接跳转到结账页面
        window.location.href = '/checkout';
      } else {
        // 没有选择upsell产品，只是添加了免费赠品，需要更新购物车显示并打开抽屉
        
        if (cart && result.sections) {
          // 更新购物车内容
          cart.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            const html = new DOMParser().parseFromString(
              result.sections[section.id],
              'text/html'
            );
            
            if (elementToReplace) {
              elementToReplace.innerHTML = html.querySelector('#minicart-form').innerHTML;
            }
          });
          
          // 调用购物车的cartAction方法（如果存在）
          if (cart && typeof cart.cartAction === 'function') {
            cart.cartAction();
          }
          
          // 打开购物车抽屉
          cart.open();
        } else {
          // 后备方案：直接打开购物车抽屉
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }
        
        // 恢复按钮状态
        submitButton.disabled = false;
        if (loadingIcon) loadingIcon.style.opacity = '0';
        if (buttonLabel) buttonLabel.textContent = 'Add to cart';
      }

    } catch (error) {
      console.error('Error adding products to cart:', error);
      
      // 显示错误信息
      this.showError('无法添加产品到购物车，请重试');
      
      // 恢复按钮状态
      submitButton.disabled = false;
      if (loadingIcon) loadingIcon.style.opacity = '0';
      if (buttonLabel) buttonLabel.textContent = 'Add to cart';
    }
  }



  hasFreeGift() {
    const freeGiftWrapper = document.querySelector('.upsell-products-wrapper');
    if (!freeGiftWrapper) return false;
    
    const freeGiftProducts = freeGiftWrapper.dataset.freeGiftProducts;
    
    return !!(freeGiftProducts && freeGiftProducts.trim() !== '');
  }

  getFreeGiftData() {
    const freeGiftWrapper = document.querySelector('.upsell-products-wrapper');
    if (!freeGiftWrapper) return null;
    
    const freeGiftProducts = freeGiftWrapper.dataset.freeGiftProducts;
    
    if (!freeGiftProducts || freeGiftProducts.trim() === '') return null;
    
    // 解析格式: "productId1:variantId1,productId2:variantId2"
    const gifts = [];
    const productPairs = freeGiftProducts.split(',');
    
    productPairs.forEach(pair => {
      const [productId, variantId] = pair.split(':');
      if (productId && variantId) {
        gifts.push({
          productId: parseInt(productId.trim()),
          variantId: parseInt(variantId.trim())
        });
      }
    });
    
    return gifts.length > 0 ? gifts : null;
  }

  showError(message) {
    const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
    const errorMessage = document.querySelector('.product-form__error-message');
    
    if (errorWrapper && errorMessage) {
      errorMessage.textContent = message;
      errorWrapper.hidden = false;
    }
  }
}

// 初始化
document.addEventListener('DOMContentLoaded', () => {
  new ProductUpsell();
}); 